import { Box, Flex, Link, Text, useDisclosure } from '@chakra-ui/react';
import { ArrowRightIcon } from '@udacity/chakra-uds-icons';

import { Markdown } from '~/components/markdown';
import { Modal } from '~/components/modal';
import { SanityImage } from '~/components/sanity-image';
import { trackEvent } from '~/features/analytics/track-event';

import { EnterpriseResourcePerson as EnterpriseResourcePersonType } from '../models/enterprise-webinar-content';

export function EnterpriseResourcePerson({ person }: { person: EnterpriseResourcePersonType }) {
  const { isOpen, onOpen, onClose } = useDisclosure({
    onOpen: () =>
      trackEvent({
        type: 'click',
        name: 'Enterprise CTA Clicked',
        label: 'person_bio_clicked',
        value: person.name,
      }),
  });

  return (
    <Box alignItems='center' display='flex'>
      <SanityImage alt='' height={64} image={person.image} sizes='64px' style={{ borderRadius: '50%' }} width={64} />

      <Box marginLeft='24px'>
        <Text fontSize='20px'>{person.name}</Text>
        <Text>{person.title}</Text>

        {person.bio && (
          <Box>
            <Link as='button' marginTop='8px' onClick={onOpen}>
              Read bio
              <ArrowRightIcon h='24px' w='24px' />
            </Link>

            <Modal isOpen={isOpen} size='3xl' title={person.name} onClose={onClose}>
              <Flex
                alignItems={{ base: 'center', md: 'flex-start' }}
                flexDirection={{ base: 'column', md: 'row' }}
                gap='40px'
              >
                <SanityImage
                  height={250}
                  image={person.image}
                  priority={true}
                  style={{ borderRadius: '4px', objectFit: 'cover' }}
                  width={256}
                />
                <Markdown markdownText={person.bio} />
              </Flex>
            </Modal>
          </Box>
        )}
      </Box>
    </Box>
  );
}
